// auth.guard.ts
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';
import { UserService } from '../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {


  constructor(private router: Router,private service : UserService) {
  }
  jwtHelper: JwtHelper = new JwtHelper();
 
  useJwtHelper() {
    var token = localStorage.getItem('token');
   
    console.log(
      this.jwtHelper.decodeToken(token),
      this.jwtHelper.getTokenExpirationDate(token),
      this.jwtHelper.isTokenExpired(token)
    );
  }
  canActivate(
  
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    if (localStorage.getItem('token') != null){
      //debugger;
      let roles = next.data['permittedRoles'] as Array<string>;
    
      if(roles){
        // console.log(
        //   this.jwtHelper.decodeToken('token'),
        //   this.jwtHelper.getTokenExpirationDate('token'),
        //   this.jwtHelper.isTokenExpired('token')
        // );
        if(this.service.roleMatch(roles)) return true;
        else{
          this.router.navigate(['/forbidden']);
          return false;
        }
      }
      return true;
    }
    else {
      this.router.navigate(['/login']);
      return false;
    }

  }
}
